module.exports = __webpack_public_path__ + "img/3.9fb9c3b6.webp";